import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import  { AxiosStrapi } from "../axiosInstance";
import {  strapiApiEndPoints } from "../../api";

const initialState = {
  data: null,
  isLoading: false,
  error: null,
};

export const fetchOffers = createAsyncThunk(
  "fetchOffers",
  (queryString, { rejectWithValue }) => {
    return AxiosStrapi.get(`${strapiApiEndPoints.offersData}`).then((res) => res.data);
  }
);

export const offersSlice = createSlice({
  name: "offers slice",
  initialState,
  reducers: {
    clearOffersError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    // FETCH  UTILS API
    builder.addCase(fetchOffers.pending, (state, action) => {
      if (!state.data) {
        state.isLoading = true;
      }
    });
    builder.addCase(fetchOffers.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload?.data;
    });
    builder.addCase(fetchOffers.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error?.message;
    });
  },
});

// SELECTORS
export const selectOffersDatatWhole = (store) => store?.offers;
export const selectOffersData = (store) => store?.offers?.data;
export const selectOffersDataLoader = (store) => store?.offers?.isLoading;

// ACTIONS TO DISPATCH
export const { clearOffersError } = offersSlice.actions;

export default offersSlice.reducer;
